import { trigger, state, style, transition, animate, AUTO_STYLE } from '@angular/animations';

export const SLIDE_ANIMATION = [
  trigger('slide', [
    state(
      'open',
      style({
        height: AUTO_STYLE
      })
    ),
    state(
      'closed-desktop',
      style({
        height: '{{ closedDesktopHeight }}'
      }),
      { params: { closedDesktopHeight: '50px' } }
    ),
    state(
      'closed-mobile',
      style({
        height: '{{ closedMobileHeight }}'
      }),
      { params: { closedMobileHeight: '102px' } }
    ),
    transition('closed-desktop => open', animate('{{ time }} ease-in')),
    transition('closed-mobile => open', animate('{{ time }} ease-in')),
    transition('open => closed-desktop', animate('{{ time }} ease-out')),
    transition('open => closed-mobile', animate('{{ time }} ease-out'))
  ])
];
